import { IElevioEvents } from './events';

// TODO: should I pass in an error handler? maybe then we can retry?
interface Config {
  type: string;
  endpointURL: string;
}
let _config: Config | undefined;

function formatData(events: Array<IElevioEvents>) {
  if (!_config) throw new Error('Config not set');
  return {
    type: _config.type,
    events,
  };
}

// https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API#Browser_compatibility
export function beaconSender(events: Array<IElevioEvents>) {
  if (!_config) throw new Error('Config not set');
  const sent = navigator.sendBeacon(
    _config.endpointURL,
    JSON.stringify(formatData(events))
  );
  if (!sent) throw new Error('Sending failed');
}

// This is just used for IE11
export function XMLHttpSender(events: Array<IElevioEvents>, isSync: boolean) {
  if (!_config) throw new Error('Config not set');

  const req = new XMLHttpRequest();
  req.open('POST', _config.endpointURL, !isSync);
  req.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
  req.send(JSON.stringify(formatData(events)));
  // TODO: throw error?
  // req.onerror((_this, ev) => {});
}

/**
 * This sends the array of events to the server but returns a promise so you can
 * wait to make sure they get sent correctly.
 * @param events the array of events to send.
 */
export function promiseSender(events: Array<IElevioEvents>): Promise<void> {
  if (!_config) throw new Error('Config not set');
  const req = new XMLHttpRequest();

  return new Promise((resolve, reject) => {
    if (!_config) throw new Error('Config not set');

    // Setup our listener to process completed requests
    req.onreadystatechange = () => {
      // Only run if the req is complete
      if (req.readyState !== 4) return;

      // Process the response
      if (req.status >= 200 && req.status < 300) {
        resolve();
      } else {
        reject({
          status: req.status,
          statusText: req.statusText,
        });
      }
    };

    req.open('POST', _config.endpointURL, true);
    req.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    req.send(JSON.stringify(formatData(events)));
  });
}

export default function getSender(config: Config): typeof XMLHttpSender {
  _config = config;
  // So Cypress can see the events
  return !!navigator.sendBeacon ? beaconSender : XMLHttpSender;
}
